import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { Row, Col, Button, Table, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faCheckSquare } from "@fortawesome/free-solid-svg-icons";
import {
  GENERAL_ADMIN,
  PENDING,
  SET_PROJECTS_PAGINATION,
  RESET_PROJECTS_PAGINATION,
  fetchProjects,
  resetProject,
  disableProject,
  enableProject,
  setProjectFilter,
  resetProjectFilter,
  clearProjects,
  sieveProject,
} from "../../store/actions/projects/projectsActions";
import {
  MANAGER,
  PORTAL_ADMIN,
  PROJECT_ADMIN,
  PROJECT_SPONSOR,
  FINANCE_APPROVER,
  TEAM_LEADER,
  EMPLOYEE,
} from "../../store/actions/users/usersActions";
import {
  togglePrompt,
  resetPagination,
} from "../../store/actions/commonActions";
import { ConfirmDialog } from "../../common/Utilities";
import { Cache } from "aws-amplify";
import ListPagination from "../../common/ListPagination";
import PageTitle from "../../common/PageTitle";

class Projects extends Component {
  constructor(props) {
    super(props);
    this.project = {};
    this.defaultRole = {};
    this.showDisableProjects = false;
    this.enableProject = "ENABLE_PROJECT";
    this.disableProject = "DISABLE_PROJECT";
    this.action = "";
    this.projectFilter = {};
    this.roleId = Cache.getItem("roleId");
  }

  componentDidMount() {
    const roleId = Cache.getItem("roleId");
    let filters = {
      is_disabled: 0,
    };

    const pathname = this.props.location.pathname;

    if (pathname === "/projects/disabled") {
      filters = {
        is_disabled: 1,
      };
      this.showDisableProjects = true;
    } else {
      this.showDisableProjects = false;
    }

    this.props.resetProjectFilter();

    if (
      roleId === MANAGER ||
      roleId === PORTAL_ADMIN ||
      roleId === PROJECT_ADMIN ||
      roleId === FINANCE_APPROVER ||
      roleId === PROJECT_SPONSOR ||
      roleId === TEAM_LEADER ||
      roleId === EMPLOYEE
    ) {
      if (roleId === MANAGER) {
        const userId = Cache.getItem("userId");
        this.projectFilter = {
          project_manager: userId,
        };
      }

      if (roleId === PROJECT_SPONSOR) {
        const userId = Cache.getItem("userId");
        this.projectFilter = {
          project_sponsor: userId,
        };
      }

      if (roleId === TEAM_LEADER || roleId === EMPLOYEE) {
        const userId = Cache.getItem('userId');
        this.projectFilter = {
          userId: userId,
        }
      }

      if (Object.keys(this.projectFilter).length) {
        Object.assign(filters, this.projectFilter);
      }

      this.props.setProjectFilter(filters);
      this.props.fetchProjects(filters);
    } else {
      this.props.history.push("/dashboard");
    }

    this.props.resetProject();
    this.props.sieveProject("");
    this.props.resetPagination(RESET_PROJECTS_PAGINATION);
  }

  componentWillUnmount() {
    this.props.clearProjects();
  }

  sieveProjects = () => {
    return (
      <Form.Control
        size="xl"
        type="search"
        placeholder="Filter Projects"
        onChange={(e) => {
          const sieve = e.target.value;
          this.props.sieveProject(sieve);
        }}
      />
    );
  };

  promptModal = () => {
    let modalTitle = "";
    let modalBody = "";
    let verb = "";

    if (this.action === this.enableProject) {
      modalTitle = "Enable Project";
      verb = "enable";
    } else {
      modalTitle = "Disable Project";
      verb = "disable";
    }

    modalBody = "Are you sure you want to " + verb + " this project?";

    const onHideFunction = () => {
      this.props.togglePrompt(false);
    };

    const onClickCancel = () => {
      this.props.togglePrompt(false);
    };

    const onClickConfirm = () => {
      if (this.action === this.enableProject) {
        this.props.enableProject(this.project.id);
      } else {
        this.props.disableProject(this.project.id);
      }
      this.props.togglePrompt(false);
    };

    return (
      <ConfirmDialog
        show={this.props.common.togglePrompt}
        modalTitle={modalTitle}
        modalBody={modalBody}
        onHideFunction={onHideFunction}
        onClickCancel={onClickCancel}
        onClickConfirm={onClickConfirm}
      />
    );
  };

  getFilteredProjects = (projects) => {
    if (!projects) {
      return null;
    }

    if (!projects.length) {
      return [];
    }

    return projects.filter((project) => {
      const code = project.code || "";
      const clientName = project.client ? project.client.client_name || "" : "";
      const clientCode = project.client ? project.client.client_code || "" : "";
      const projectName = project.project_name || "";
      const status = project.status || "";

      const projectData = [code, clientName, clientCode, projectName, status]
        .join(" ")
        .toLowerCase();

      const projectSieve = this.props.projects.projectSieve;

      if (!projectSieve || projectData.includes(projectSieve.toLowerCase())) {
        return project;
      }
      return null;
    });
  };

  renderProjects = () => {
    this.defaultRole = this.props.users.defaultUserRole;

    let projects = this.getFilteredProjects(this.props.projects.projects);

    if (projects) {
      //if the user tries to search and no matches the filter
      if (this.props.projects.projectSieve && !projects.length) {
        projects = null;
      } else {
        let min = this.props.projects.min;
        let max = this.props.projects.max;

        //don't paginate if there's filter
        if (!this.props.projects.projectSieve) {
          projects = projects.slice(min - 1, max);
        }
      }
    }

    let projectsList = [];

    if (projects) {
      projectsList =
        projects.length > 0 ? (
          projects
            .filter((project) => project.project_id !== GENERAL_ADMIN)
            .filter((project) => {
              const code = project.code || "";
              const clientName = project.client
                ? project.client.client_name || ""
                : "";
              const clientCode = project.client
                ? project.client.client_code || ""
                : "";
              const projectName = project.project_name || "";
              const status = project.status || "";

              const projectData = [
                code,
                clientName,
                clientCode,
                projectName,
                status,
              ]
                .join(" ")
                .toLowerCase();

              const projectSieve = this.props.projects.projectSieve;

              if (
                !projectSieve ||
                projectData.includes(projectSieve.toLowerCase())
              ) {
                return project;
              }
              return null;
            })
            .map((project, key) => {
              let clientName = "";

              if (project && typeof project.client !== "undefined") {
                const client = project.client;
                if (client && typeof client.id !== "undefined") {
                  clientName = client.client_name;
                }
              }

              return (
                <tr
                  key={key}
                  className={project.status === PENDING ? "text-muted" : ""}
                >
                  <td>
                    {
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.props.resetProject();
                          this.props.history.push(
                            "/projects/view?id=" + project.id
                          );
                        }}
                      >
                        {project.project_name}
                      </Link>
                    }
                  </td>
                  <td>{clientName}</td>

                  {this.roleId !== EMPLOYEE ? (
                    <td className="align-center"> {project.status}</td>
                  ) : (
                    <td className="align-center"> {project.start_date}</td>
                  )}

                  {this.roleId === EMPLOYEE ? (
                    <td className="align-center"> {project.end_date}</td>
                  ) : (
                    ""
                  )}

                  {this.roleId === PORTAL_ADMIN ||
                  this.roleId === PROJECT_ADMIN ? (
                    <td className="align-right ">
                      {project.is_disabled ? (
                        <Button
                          size="sm"
                          className="btn-icon"
                          onClick={() => {
                            this.project = project;
                            this.action = this.enableProject;
                            this.props.togglePrompt(true);
                          }}
                        >
                          <FontAwesomeIcon icon={faCheckSquare} /> Enable
                        </Button>
                      ) : (
                        <Button
                          size="sm"
                          className="btn-icon"
                          onClick={() => {
                            this.project = project;
                            this.action = this.disableProject;
                            this.props.togglePrompt(true);
                          }}
                        >
                          <FontAwesomeIcon icon={faBan} /> Disable
                        </Button>
                      )}
                    </td>
                  ) : (
                    ""
                  )}
                </tr>
              );
            })
        ) : (
          <tr>
            <td colSpan={4}>
              <i>Loading...</i>
            </td>
          </tr>
        );
    } else {
      projectsList = (
        <tr>
          <td colSpan={4}>
            <p className="text-danger">No projects found.</p>
          </td>
        </tr>
      );
    }

    return (
      <Table hover>
        <thead className="align-center">
          <tr>
            <th width="40%" className="align-center">
              Project Name
            </th>
            <th width="30%" className="align-center">
              Client
            </th>
            {this.roleId !== EMPLOYEE ? (
              <th width="30%">Status</th>
            ) : (
              <th width="30%">Start Date</th>
            )}
            {this.roleId === EMPLOYEE ? <th width="30%">End Date</th> : ""}
            {this.roleId === PORTAL_ADMIN || this.roleId === PROJECT_ADMIN ? (
              <th width="30%">Actions</th>
            ) : (
              ""
            )}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan={4}>{this.sieveProjects()}</td>
          </tr>
          {projectsList}
        </tbody>
      </Table>
    );
  };

  displayCreateButton = () => {
    const roleId = Cache.getItem("roleId");
    if (
      roleId !== PORTAL_ADMIN &&
      roleId !== PROJECT_ADMIN
      // roleId !== MANAGER
    ) {
      return "";
    }

    return (
      <div className="float-right">
        <Button
          size="sm"
          onClick={() => {
            this.props.history.push("/projects/add");
          }}
        >
          Create Project
        </Button>
      </div>
    );
  };

  render() {
    const projects = this.props.projects.projects;

    const listPagination =
      !this.props.projects.projectSieve && projects ? (
        <ListPagination
          dispatchType={SET_PROJECTS_PAGINATION}
          data={this.props.projects.projects}
          min={this.props.projects.min}
          max={this.props.projects.max}
          currentPage={this.props.projects.currentPage}
          totalPages={this.props.projects.totalPages}
          fetchCallback=""
          numItems={this.props.projects.numItems}
        />
      ) : (
        ""
      );

    return (
      <React.Fragment>
        {this.promptModal()}
        <PageTitle
          pageName={this.showDisableProjects ? "Disabled Projects" : "Projects"}
          actionButton={this.displayCreateButton()}
        />
        <Row className="mt-3">
          <Col>
            {this.showDisableProjects ? (
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => {
                  this.props.history.push("/projects");
                  this.showDisableProjects = false;
                  this.props.resetPagination(RESET_PROJECTS_PAGINATION);
                  this.props.clearProjects();
                  Object.assign(this.projectFilter, { is_disabled: 0 });
                  this.props.setProjectFilter(this.projectFilter);
                  this.props.fetchProjects(this.projectFilter);
                }}
              >
                Show Active Projects
              </Button>
            ) : (
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => {
                  this.props.history.push("/projects/disabled");
                  this.showDisableProjects = true;
                  this.props.resetPagination(RESET_PROJECTS_PAGINATION);
                  this.props.clearProjects();
                  Object.assign(this.projectFilter, { is_disabled: 1 });
                  this.props.setProjectFilter(this.projectFilter);
                  this.props.fetchProjects(this.projectFilter);
                }}
              >
                Show Disabled Projects
              </Button>
            )}
          </Col>
          <Col xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="float-right">{listPagination}</div>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            {this.renderProjects()}
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="float-right">{listPagination}</div>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
  users: state.users,
  common: state.common,
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchProjects: (...args) => dispatch(fetchProjects(...args)),
    resetProject: () => dispatch(resetProject()),
    disableProject: (...args) => dispatch(disableProject(...args)),
    enableProject: (...args) => dispatch(enableProject(...args)),
    togglePrompt: (...args) => dispatch(togglePrompt(...args)),
    clearProjects: () => dispatch(clearProjects()),
    setProjectFilter: (...args) => dispatch(setProjectFilter(...args)),
    resetProjectFilter: () => dispatch(resetProjectFilter()),
    sieveProject: (...args) => dispatch(sieveProject(...args)),
    resetPagination: (...args) => dispatch(resetPagination(...args)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Projects)
);
